<template>

    <div id="gridSwit" class="d-none d-md-flex align-items-center justify-content-end">

        <button @click='goGrid' :class="['btn btn-link', !listMode ? 'active' : '']">
            <span class="icon icon-dashboard-4"></span> 
        </button>

        <button @click='goList' :class="['btn btn-link', listMode ? 'active' : '']">
            <span class="icon icon-split-screen-horizontal"></span> 
        </button>

    </div>

</template>

<script>
    export default {

        mounted() {
            var lm = localStorage.getItem('_lm');

            if( lm ) {
                this.$nextTick( () => {
                   this.goList(); 
                }) 
            }

        },

        created() {
        },

        data() {
            return {
                isReady : false,
                listMode : false
            }
        },

        methods : {

            goGrid() {
                $("#tool-listing").removeClass("list-mode");
                this.listMode = false;

                localStorage.removeItem('_lm');
            },

            goList() {
                $("#tool-listing").addClass("list-mode");
                this.listMode = true;

                localStorage.setItem('_lm',1);
            }

        }

    }
</script>
